import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import axios from 'axios';
import qs from 'qs';
import { escapeHtml, rescueHtml } from './Tools';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { ReactComponent as Add } from '../Img/icon-add.svg';

const CreateBudget = (props) =>
{
    const [organismes, setOrganismes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const green = '#59B44A';

    useEffect(() => {
        if (props.organismes && props.organismes.length > 0) {
            var tmp = [];
            for (let i = 0; i < props.organismes.length; i++) {
                tmp[i] = {
                    id: props.organismes[i].id,
                    nom: rescueHtml(props.organismes[i].nom)
                }
            }
            setOrganismes(tmp);
            setIsLoading(false);
        }
    }, [props.organismes])

    // Resultat du formulaire
    const { register, handleSubmit } = useForm();
    
    const onSubmit = data => {
        if (data.id_organisme != '' && data.nom != '' && data.siret != '' && data.nomen != '' && data.budget_annexe != '')
        {
            const params = {
                'feed_budgets': true,
                'budget_list': [{'id_organisme': data.id_organisme, 'nom': escapeHtml(data.nom), 'siret': data.siret, 'budget_annexe': data.budget_annexe, 'nomen': data.nomen.toUpperCase()}]
            };
            axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify(params))
            .then(async function (result) {
                if (result.data['status'] === 1) {
                    NotificationManager.success(result.data['status_message'], '', 700);
                    setTimeout(() => window.location = window.location.href, 900);
                }
                else {
                    NotificationManager.warning(result.data['status_message'], '', 5000);
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
        else {
            NotificationManager.warning('Champ manquant', '', 5000);
        }
    };

	return (
        <div className='shadow-xl' style={{textAlign: 'center',  borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white'}}>
            <NotificationContainer />
            <p>Créer un budget :</p>
            {isLoading ? (
                <div style={{margin: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 150}}>
                    <div className='spinner' style={{
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #6571FE',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        animation: 'spin 1s linear infinite'
                    }}>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
            ) : (
            <form style={{textAlign: 'left', textAlign: 'center'}} onSubmit={handleSubmit(onSubmit)}>
                <div style={{margin: 10}}>
                    <div style={{margin: 10}}>
                        <select className='shadow-md' style={{width: 250, padding: 5}} {...register("id_organisme")}>
                            <option value="">...</option>
                            {
                                organismes.map((organisme) => 
                                <option key={organisme['id']} value={organisme['id']}>{organisme['nom']}</option>
                                )
                            }
                        </select>
                    </div>

                    <div style={{margin: 10}}>
                        <select className='shadow-md' style={{width: 250, padding: 5}} {...register("budget_annexe")}>
                            <option value="0">BUDGET PRINCIPAL</option>
                            <option value="1">BUDGET ANNEXE</option>
                        </select>
                    </div>

                    <div style={{margin: 10}}><input className='shadow-md' style={{width: 250}} placeholder='Nom' {...register("nom")} /></div>
                    <div style={{margin: 10}}><input className='shadow-md' style={{width: 250}} placeholder='Siret' {...register("siret")} /></div>
                    <div style={{margin: 10}}><input className='shadow-md' style={{width: 250}} placeholder='Nomenclature ex: M57' {...register("nomen")} /></div>
                    
                    
                    <div style={{margin: 10, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                        <div style={{display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, paddingLeft: 10}}>
                            <Add width="12" />
                            <input style={{marginLeft: 5, fontSize: 14, paddingLeft: 5, paddingRight: 15}} type="submit" value="Créer" />
                        </div>
                    </div>
                </div>
            </form>
            )}
        </div>
	);
}

export default CreateBudget;
